const BASE_URL = process.env.REACT_APP_API_URL || '/api';

export function getToken() {
  return localStorage.getItem('aspyn_token');
}

export function setToken(token) {
  localStorage.setItem('aspyn_token', token);
}

export function clearToken() {
  localStorage.removeItem('aspyn_token');
  localStorage.removeItem('aspyn_user');
}

export async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const res = await fetch(`${BASE_URL}${path}`, { ...options, headers });

  if (res.status === 401) {
    clearToken();
    window.location.reload();
    throw new Error('Session expired');
  }

  if (!res.ok) throw new Error(`API error ${res.status}: ${res.statusText}`);
  return res.json();
}
